import { useUserMe } from '@/hooks/useUserMe';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

export const useIsOrganizationMember = () => {
  const organizationId = useOrganizationId();

  const user = useUserMe().data;
  const isStaffUser = user?.is_staff ?? false;

  if (isStaffUser) return true;

  const userOrganizationId = user.membership.organization?.id;

  return organizationId === userOrganizationId;
};
